import React from "react";
import { Helmet } from "react-helmet-async";
import seoData from "../../assets/data/seo.json";

const PrivacyPolicy = () => {
  const seo = seoData["privacy-policy"] || {};
  const { title, description, keywords, canonical } = seo;

  return (
    <div className="bg-white min-h-screen">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {keywords && <meta name="keywords" content={keywords} />}
        {canonical && <link rel="canonical" href={canonical} />}
      </Helmet>

      <section className="py-20 bg-gray-50 border-b border-gray-100">
        <div className="container mx-auto px-6 text-center">
          <h1 className="font-bold text-gray-900 uppercase tracking-tight text-[28px] md:text-[50px] lg:text-[72px]">Privacy Policy</h1>
          <p className="mt-4 text-gray-500 max-w-2xl mx-auto font-medium text-[12px] md:text-[14px] lg:text-[16px]">Last updated: March 2026</p>
        </div>
      </section>

      <section className="py-20 container mx-auto px-6 max-w-4xl">
        <div className="prose prose-red max-w-none text-gray-600 space-y-8 font-medium">
          <p>
            Jetty Estates ("we", "us", or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard information from our website visitors, clients, and property buyers.
          </p>

          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">1. Information We Collect</h2>
            <p>We may collect personal information such as your name, email address, phone number, and mailing address when you submit inquiries, sign up for our newsletter, or request property listings. For inquiries, we collect preferences and financial ranges to provide curated options.</p>
          </div>

          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">2. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-2 text-[14px]">
              <li>To schedule viewings, process property inquiries, and respond to your requests.</li>
              <li>To send customized updates about premium listings, newsletters, and services.</li>
              <li>To improve our brokerage services and website usability.</li>
              <li>To comply with real estate licensing laws and regulatory requirements.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">3. Data Protection</h2>
            <p>We implement industry-standard security measures to protect your data. Your personal information is stored securely. We do not sell, trade, or share your personal information with unrelated third parties, except as required to complete transactions through escrow or title agents.</p>
          </div>

          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">4. Cookies</h2>
            <p>Our website uses cookies to enhance user experience. You can choose to disable cookies in your browser settings, though some parts of the site may not function optimally.</p>
          </div>

          <div>
            <h2 className="font-bold text-gray-900 mb-4 uppercase text-[26px] md:text-[48px]">5. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us at:</p>
            <div className="mt-4 p-6 bg-gray-50 rounded-2xl border border-gray-100 italic">
              Jetty Estates<br />
              Email: mail@jettyestates.com<br />
              Phone: +1 (310) 555-0198
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
